import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPaintBrush,
  faPalette,
  faFaceSmile,
  faWandMagicSparkles,
} from "@fortawesome/free-solid-svg-icons";
import BookingModal from "../Hero/BookingModal";
import "./Services.css";

function Services() {
  const [showModal, setShowModal] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);

  const services = [
    {
      icon: faPalette,
      title: "Slikarske radionice",
      image: "slikarske-radionice.jpg",
      description:
        "Kroz slikanje na platnu, papiru i različitim površinama djeca razvijaju kreativnost i motoričke vještine. Koristimo kvalitetne, netoksične boje prilagođene djeci svih uzrasta.",
      fullDescription: (
        <>
          <p>
            Kad dijete primi kist u ruke, ono ne slika samo svijet, ono ga
            stvara ispočetka.
          </p>

          <p>
            Na našim slikarskim radionicama djeca istražuju svijet boja, oblika
            i osjećaja kroz slobodno i vođeno slikanje. Nema pogrešnih poteza ni
            granica. Svaka mrlja, svaka linija i svaka kap boje dio su njihove
            priče.
          </p>

          <p>
            Cilj nije "lijepo naslikati", nego doživjeti stvaranje: uživati u
            procesu, izraziti emocije i otkriti koliko umjetnost može biti
            zabavna, opuštajuća i oslobađajuća.
          </p>

          <h5 className="mt-4">Što radimo na slikarskim radionicama</h5>
          <ul>
            <li>
              Upoznajemo se s različitim slikarskim tehnikama: tempera, akril,
              akvarel
            </li>
            <li>
              Učimo kako koristiti boje, kistove, spužvice i prste kao alate
              izraza
            </li>
            <li>
              Istražujemo tonove, kontraste i oblike kroz igru i eksperiment
            </li>
            <li>Slikamo motive iz prirode, bajki, emocija i dječjih snova</li>
            <li>
              Uključujemo elemente art terapije i radimo u smirenoj, poticajnoj
              atmosferi gdje svatko ima svoj tempo
            </li>
            <li>
              Marina, umjetnica i edukantica art terapije, vodi svaku radionicu
              s pažnjom, osmijehom i individualnim pristupom
            </li>
          </ul>

          <h5 className="mt-4">Zašto su naše slikarske radionice posebne</h5>
          <ul>
            <li>Potiču maštu, samopouzdanje i koncentraciju</li>
            <li>Razvijaju osjećaj boje, kompozicije i estetike</li>
            <li>Djeluju umirujuće i potiču izražavanje emocija</li>
            <li>Spajaju umjetnost, igru i terapijski doživljaj</li>
            <li>
              Svako dijete odlazi ponosno sa svojim radom, malim komadićem sebe
              u boji
            </li>
          </ul>

          <h5 className="mt-4">Gdje ih održavamo</h5>
          <p>
            Na rođendanima • U školama i vrtićima • U dječjim igraonicama i
            centrima • Na festivalima i događajima • U privatnim terminima i
            manjim grupama
          </p>
        </>
      ),
    },
    {
      icon: faPaintBrush,
      title: "Kreativne radionice",
      image: "kreativne-radionice.jpg",
      description:
        "Od izrade nakita, ukrašavanja maski, rada s glinom do reciklažnih projekata - djeca istražuju različite materijale i tehnike kroz zabavne projekte.",
      fullDescription: (
        <>
          <p>
            U Art&Fun Clubu vjerujemo da je svako dijete umjetnik, samo mu
            trebaju boje, vrijeme i netko tko vjeruje u njegovu maštu.
          </p>

          <p>
            Naše kreativne radionice nisu samo zabava, one su iskustvo
            otkrivanja, izražavanja i povezivanja.
          </p>

          <p>
            Kroz slikanje, crtanje, modeliranje i istraživanje različitih
            materijala, djeca uče kako izraziti svoje emocije. Razvijaju
            koncentraciju i samopouzdanje, a sve to kroz igru i osmijeh.
          </p>

          <p>
            Svaka radionica je pažljivo osmišljena kako bi potaknula dječju
            znatiželju i slobodu izraza. Koristimo raznovrsne tehnike i pristupe
            (od tempera, kolaža i recikliranog materijala do prirodnih
            materijala i tematskih projekata).
          </p>

          <p>
            Fokus nije na rezultatu, već na procesu stvaranja jer u umjetnosti
            ne postoje pogreške, već samo nova otkrića.
          </p>

          <h5 className="mt-4">Što radionice uključuju</h5>
          <ul>
            <li>Likovne radionice prilagođene dobi djece</li>
            <li>Eksperimentiranje s bojama, oblicima i teksturama</li>
            <li>
              Tematske radionice (godišnja doba, priroda, emocije, bajke…)
            </li>
            <li>Rad u malim grupama uz individualni pristup</li>
            <li>Umirujuća atmosfera s elementima art terapije</li>
            <li>
              Stručno i toplo vođenje s pažnjom, osmijehom i razumijevanjem
            </li>
          </ul>

          <h5 className="mt-4">Zašto su posebne?</h5>
          <ul>
            <li>Razvijaju kreativnost i fokus i finu motoriku</li>
            <li>Potiču samosvijest i izražavanje emocija</li>
            <li>Nude prostor za mir, igru i zajedništvo</li>
            <li>
              Djeca odlaze s osmjehom i ponosom jer ono što su stvorili ima
              smisaj i ljepotu
            </li>
          </ul>

          <h5 className="mt-4">Gdje ih organiziramo</h5>
          <p>
            Rođendani • Vrtići i škole • Dječje igraonice • Eventi i festivali •
            Privatni termini i posebne prigode
          </p>

          <p className="mt-3">
            <em>
              Na svakoj radionici stvaramo mali svemir boja i emocija, mjesto
              gdje svako dijete može biti točno što jest.
            </em>
          </p>
        </>
      ),
    },
    {
      icon: faFaceSmile,
      title: "Facepainting",
      image: "facepainting.jpg",
      description:
        "Od dječjih rođendana i vjenčanja do gradskih događanja i festivala, facepaintingom stvaramo trenutke u kojima se djeca i odrasli pretvaraju u superjunake, vile, leptiriće, tigrice i bića iz vlastitih snova.",
      fullDescription: (
        <>
          <h5>Umjetnost koja oživljava maštu</h5>
          <p>
            Facepainting nije samo zabavna aktivnost, to je umjetnost koja
            oživljava maštu. Svako lice postaje platno, svaka boja postaje
            osjećaj, svaka linija dio priče.
          </p>

          <p>
            Od dječjih rođendana i vjenčanja do gradskih događaja i festivala,
            facepaintingom stvaramo trenutke u kojima se djeca i odrasli
            pretvaraju u superjunake, vile, leptiriće, tigrice i bića iz
            vlastitih snova.
          </p>

          <p>
            Ova drevna praksa razvijala se kroz stoljeća, a danas spaja
            umjetnost, igru i izražavanje osobnosti. Umjetnici koriste posebne
            profesionalne boje i alate (kistove i spužvice) kako bi stvorili
            nježne prijelaze, precizne linije i svjetlucave detalje.
          </p>

          <p>
            Boje koje koristimo su sigurne, hipoalergenske i perive. Dolaze u
            različitim tonovima i završnim efektima, od mat do sjajnih i
            šljokičastih.
          </p>

          <p>
            Inspiraciju pronalazimo svugdje oko sebe: u prirodi, godišnjim
            dobima, popularnim likovima i dječjoj mašti. Ljeto donosi cvjetne
            motive i tropske boje, a zima vilenjake i čaroliju snijega.
          </p>

          <p>
            No najvažniji dio našeg posla nije boja već susret s djetetom.
            Uvijek pitamo što voli, što ga veseli, što želi postati. Kad dijete
            sa sjajem u očima kaže: "Želim biti vila!", tu počinje prava
            čarolija.
          </p>

          <p>
            <strong>
              Jer facepainting nije samo slikanje po licu nego je trenutak
              povezanosti, povjerenja i čiste radosti.
            </strong>
          </p>
        </>
      ),
    },
    {
      icon: faWandMagicSparkles,
      title: "Kreativna animacija",
      image: "kreativna-animacija.jpg",
      description:
        "Dok odrasli slave, djeca stvaraju, istražuju i maštaju. Naš kreativni dječji kutak osmišljen je kao sigurno, veselo i kreativno mjesto gdje se najmlađi uzvanici osjećaju uključeno, zaštićeno i sretno.",
      fullDescription: (
        <>
          <p>
            Dok odrasli slave, djeca stvaraju, istražuju i maštaju. Naš
            kreativni dječji kutak osmišljen je kao sigurno, veselo i kreativno
            mjesto gdje se najmlađi uzvanici osjećaju uključeno, zaštićeno i
            sretno.
          </p>

          <p>
            Art&Fun animacija spaja umjetnost, igru i pažnju. Svako dijete
            dobiva prostor da se izrazi kroz kreativne aktivnosti, a roditelji
            mogu bezbrižno uživati u proslavi znajući da su njihovi mališani u
            sigurnim rukama.
          </p>

          <h5 className="mt-4">Što uključuje naš paket za animaciju</h5>
          <ul>
            <li>Educirani iskusni animatori s umjetničkim pristupom</li>
            <li>
              Stručno vođenje i animacija djece kroz zabavne i kreativne
              programe
            </li>
            <li>Mini likovna radionica i mala "umjetnička kolonija"</li>
            <li>Dječji stol s materijalima za crtanje, slikanje i igru</li>
            <li>Društvene i natjecateljske igre prilagođene dobi</li>
            <li>Facepainting i glitter kutak</li>
            <li>Poklon-ići i sitna iznenađenja za mališane</li>
            <li>
              Suradnja i komunikacija s roditeljima tijekom cijelog događaja
            </li>
            <li>Dolazak, postava i raspremanje prostora</li>
          </ul>

          <h5 className="mt-4">Sigurnost i profesionalnost</h5>
          <p>
            Sva oprema, materijali i boje koje koristimo su sigurni, provjereni
            i netoksični.
          </p>
          <p>
            Naši animatori i "tete čuvalice" su edukativno i pedagoški
            usmjereni, s iskustvom u radu s djecom različitih uzrasta.
          </p>
          <p>
            Brinemo o svemu, od sjedenja i posluživanja, do igara, likovnih
            aktivnosti i plesanja i malih glazbenih trenutaka uz puno pažnje,
            empatije i osmijeha.
          </p>

          <h5 className="mt-4">Zašto odabrati Art&Fun animaciju</h5>
          <ul>
            <li>Kombiniramo zabavu, kreativnost i umjetničko izražavanje</li>
            <li>Stvaramo smirenu, sigurnu i veselu atmosferu</li>
            <li>
              Dječji kutak postaje mjesto boja, smijeha i novih prijateljstava
            </li>
            <li>Roditelji mogu uživati u proslavi bez brige</li>
            <li>Svaki događaj prilagođavamo temi, prostoru i uzrastu djece</li>
          </ul>

          <h5 className="mt-4">Idealno za</h5>
          <p>
            Vjenčanja • Obiteljske proslave i rođendane • Korporativne i
            sezonske evente • Kulturne i školske manifestacije
          </p>

          <p className="mt-3">
            <em>
              Art&Fun Club animacija nije samo čuvanje djece, to je čarolija
              stvaranja, igre i mašte u srcu svakog slavlja.
            </em>
          </p>
        </>
      ),
    },
  ];

  const handleCardClick = (service) => {
    setSelectedService(service);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedService(null);
  };

  const openBookingModal = () => {
    setIsBookingModalOpen(true);
  };

  const closeBookingModal = () => {
    setIsBookingModalOpen(false);
  };

  return (
    <>
      <section className="services" id="services">
        <div className="container">
          <h2 className="section-title">Naše usluge</h2>
          <div className="services-grid">
            {services.map((service, index) => (
              <div
                key={index}
                className="service-card"
                onClick={() => handleCardClick(service)}
              >
                <FontAwesomeIcon icon={service.icon} className="service-icon" />
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <span className="read-more">Saznaj više →</span>
              </div>
            ))}
          </div>
        </div>

        {showModal && selectedService && (
          <div className="modal-overlay" onClick={handleClose}>
            <div
              className="modal-container"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="modal-header-custom">
                <div className="modal-title">
                  <FontAwesomeIcon
                    icon={selectedService.icon}
                    className="modal-icon"
                  />
                  <h3>{selectedService.title}</h3>
                </div>
              </div>

              <div className="modal-body-custom">
                <div className="modal-image-container">
                  <img
                    src={`/assets/img/${selectedService.image}`}
                    alt={selectedService.title}
                    className="modal-service-image"
                  />
                </div>
                <div className="modal-content-text">
                  {selectedService.fullDescription}
                </div>
              </div>

              <div className="modal-footer-custom">
                <button className="btn btn-secondary" onClick={handleClose}>
                  Zatvori
                </button>
                <button
                  className="btn btn-primary btn-reserve"
                  onClick={openBookingModal}
                >
                  <FontAwesomeIcon icon={faWandMagicSparkles} /> Rezerviraj
                  termin
                </button>
              </div>
            </div>
          </div>
        )}
      </section>

      <BookingModal isOpen={isBookingModalOpen} onClose={closeBookingModal} />
    </>
  );
}

export default Services;
